export const sources = {
	webp: "__VITE_ASSET__q6tfGKm3Qmt5DJmATeHQdA__ 500w, __VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__ 800w, __VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__ 1080w, __VITE_ASSET__E8wuXQ_AmxPT2QBGX_$9Vw__ 1600w, __VITE_ASSET__2ZEzIIM_atdpHcr$6kvj$Q__ 2000w"
};
export const img = {
	src: "__VITE_ASSET__2ZEzIIM_atdpHcr$6kvj$Q__",
	w: 2000,
	h: 1333
};
export default {
	sources: sources,
	img: img
};
